export const selectDocument = state => state.document;
export const selectCollaborators = state => state.collaborators;
export const selectOrganization = state => state.organization;
export const selectContacts = state => state.contacts;
export const selectViewlinks = state => state.viewlinks;
export const selectFolderCollaborators = state => state.folderCollaborators;
export const selectFoldersRestrictions = state => state.foldersRestrictions;
export const selectUserPermissions = state => state.userPermissions;
export const selectUnifiedPrivacy = state => state.unifiedPrivacy;
export const selectDocumentOid = state => state.documentOid;